import React, { useEffect, useState } from 'react';

import { getAudioTrackFromMediaStream } from '../../../../../../../../helpers/audio-helper/get-audio-track';
import { useMicrophoneLevel } from '../../../../../../../../hooks/use-microphone-level';
import { useInputMediaStreamContext } from '../../../../../../hooks/use-diagnostic-mic-stream';
import { useDiagnosticVolumeLevel } from '../../../../../../hooks/use-diagnostic-volume-level';
import { diagnosticAudioLevelAnalyser } from '../../../../../utils/diagnostic-level-analyzer';
import { VolumeMeter } from '../../../../volume-meter';

export const InputDeviceLeveL = () => {
    const { mediaStream } = useInputMediaStreamContext();
    const [talkWhileMutedStream, setTalkWhileMutedStream] = useState<MediaStream | null>(null);
    useEffect(() => {
        if (!mediaStream) {
            return;
        }
        const originalAudioTrack = getAudioTrackFromMediaStream(mediaStream);
        if (!originalAudioTrack) {
            return;
        }
        const clonedAudioTrack = originalAudioTrack.clone();
        clonedAudioTrack.enabled = true;
        const talkWhileMutedStream = new MediaStream([clonedAudioTrack]);
        setTalkWhileMutedStream(talkWhileMutedStream);
        return () => {
            talkWhileMutedStream.getTracks().forEach((track) => track.stop());
            setTalkWhileMutedStream(null);
        };
    }, [mediaStream]);

    const micLevel = useMicrophoneLevel({
        externalStream: talkWhileMutedStream ?? undefined,
        customAudioLevelAnalyser: diagnosticAudioLevelAnalyser ?? undefined,
    });

    const volumeLvl = useDiagnosticVolumeLevel(micLevel);

    return <VolumeMeter volume={volumeLvl} length={8} />;
};
